<kendo-grid
  [rowReorderable]="true"
  [kendoGridBinding]="contacts()"
  [pageSize]="15"
  [pageable]="true"
  [navigable]="true"
  (add)="addHandler($event)"
  (save)="saveHandler($event)"
  (cancel)="cancelHandler($event)"
  (edit)="editHandler($event)"
  (remove)="removeHandler($event)"
  (cellClick)="cellClickHandler($event)"
  (rowReorder)="dragAndDropHandler($event)"
  class="call-tree-grid"
>
  <ng-template kendoGridToolbarTemplate>
    <div class="grid-toolbar">
      <div class="grid-title">
        <h5>
          Call Tree Setup
          <span
            *ngIf="showTooltip"
            kendoTooltip
            tooltipClass="custom-tooltip"
            title="Personnel added here will be called in the event of a suspected incident. Calls will be made in the order they are listed here."
          >
            <kendo-svg-icon [icon]="infoCircleIcon"></kendo-svg-icon>
          </span>
        </h5>
      </div>
      <button
        size="medium"
        #adminorcustomer_organizations_soccommunications_calltree_addnewcontact
        kendoGridAddCommand
        class="cyflare-btn-primary"
      >
        Add New Contact
      </button>
    </div>
  </ng-template>
  <kendo-grid-rowreorder-column [width]="40"></kendo-grid-rowreorder-column>
  <kendo-grid-column
    field="name"
    title="Name"
    [width]="170"
  >
    <ng-template kendoGridEditTemplate>
      <kendo-textbox [formControl]="formGroup!.controls.name"></kendo-textbox>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column
    [width]="140"
    field="phone"
    title="Phone #"
    editor="text"
  >
    <ng-template
      kendoGridCellTemplate
      let-dataItem="dataItem"
    >
      <span
        class="phone-number"
        [ngClass]="{ international: dataItem.phone?.startsWith('+') && !dataItem.phone?.startsWith('+1') }"
      >
        {{ formatPhoneNumber(dataItem.phone) }}
      </span>
    </ng-template>
    <ng-template kendoGridEditTemplate>
      <kendo-textbox
        [style.width.px]="140"
        [formControl]="formGroup!.controls.phone"
        placeholder="(555) 555-5555 or +XX..."
        class="phone-input"
        kendoTooltip
        title="US: (555) 555-5555 or International: +XX XXXXXXXX"
      ></kendo-textbox>
      <div
        *ngIf="formGroup!.controls.phone.errors?.['pattern']"
        class="k-form-error"
      >
        Please enter a valid phone number
      </div>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column
    [width]="100"
    field="extension"
    title="Extension"
  >
    <ng-template kendoGridEditTemplate>
      <kendo-textbox [formControl]="formGroup!.controls.extension"></kendo-textbox>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column
    [width]="100"
    field="dispatch_line"
    editor="boolean"
    title="Dispatch Line"
  >
    <ng-template
      kendoGridCellTemplate
      let-dataItem
    >
      <input
        kendoCheckBox
        type="checkbox"
        [(ngModel)]="dataItem.dispatch_line"
        [disabled]="true"
      />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column
    [width]="200"
    field="working_days"
    title="Days Available"
    editor="text"
  >
    <ng-template
      kendoGridCellTemplate
      let-dataItem
    >
      <div class="days-container">
        @for (day of dataItem.working_days; track day) {
          <kendo-chip
            [attr.data-day]="day"
            [class]="'day-chip-' + day"
            size="small"
            rounded="medium"
          >
            {{ getDayAbbreviation(day) }}
          </kendo-chip>
        } @empty {
          <span>No working days available</span>
        }
      </div>
    </ng-template>
    <ng-template kendoGridEditTemplate>
      <kendo-multiselect
        [formControl]="formGroup!.controls.working_days"
        (valueChange)="onDaysChange($event)"
        [valueField]="'value'"
        [textField]="'text'"
        [valuePrimitive]="true"
        [data]="dayOptions"
      ></kendo-multiselect>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column
    [width]="150"
    field="available_from"
    title="Available From"
    editor="date"
  >
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
    >
      <kendo-timepicker [formControl]="formGroup!.controls.available_from"></kendo-timepicker>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column
    [width]="150"
    field="available_to"
    title="Available To"
    editor="date"
  >
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
    >
      <kendo-timepicker [formControl]="formGroup!.controls.available_to"></kendo-timepicker>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column
    field="timezone"
    title="Timezone"
    editor="text"
    [width]="150"
  >
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
    >
      <kendo-dropdownlist
        placeholder="Select timezone"
        [data]="timeZones"
        [valuePrimitive]="true"
        [formControl]="formGroup!.controls.timezone"
        [style]="{ width: '100%' }"
      ></kendo-dropdownlist>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-command-column
    [width]="120"
    title=""
  >
    <ng-template
      kendoGridCellTemplate
      let-isNew="isNew"
    >
      <button
        #adminorcustomer_organizations_soarrules_serverexceptions_save
        kendoGridSaveCommand
        [disabled]="formGroup?.invalid!"
        class="cyflare-btn-primary cyflare-btn-sm"
      >
        Save
      </button>
      <button
        #adminorcustomer_organizations_soarrules_serverexceptions_remove
        kendoGridRemoveCommand
        class="cyflare-btn-danger cyflare-btn-sm"
      >
        Remove
      </button>
      <button
        #adminorcustomer_organizations_soarrules_serverexceptions_cancel
        kendoGridCancelCommand
        class="cyflare-btn-secondary cyflare-btn-sm"
      >
        Cancel
      </button>
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>
<div kendoDialogContainer></div>
